import React, { useEffect, useState } from 'react';

const styles = {
  backgroundImage: `url(/images/loading.gif)`,
  backgroundAttachment: 'fixed',
  backgroundPosition: 'center',
  backgroundColor: '#000',
  backgroundRepeat: 'no-repeat',
};

const Initial = () => {
  const [isConnection, setIsConnection] = useState(true);

  useEffect(() => {
    if (!window.navigator.onLine) {
      setIsConnection(false);
    }

    let offlineListener = window.addEventListener('offline', () => {
      setIsConnection(false);
    });

    let onlineListener = window.addEventListener('online', () => {
      setIsConnection(true);
    });
    //
    // let noInternetListener = window.addEventListener('NO_INTERNET', () => {
    //   notifyInternetError();
    // });

    return () => {
      // @ts-ignore
      window.removeEventListener('offline', offlineListener);
      // @ts-ignore
      window.removeEventListener('online', onlineListener);
      // window.removeEventListener(NO_INTERNET, noInternetListener);
    };
  }, []);

  return (
    <div style={styles} className={`h-screen flex justify-center items-center`}>
      {isConnection ? (
        <div className="padd text-center">
          <h2 className={`text-neutron`}>Initialization Connection</h2>
          <h3 className={`text-neutron mt-5`}>Please wait...</h3>
        </div>
      ) : (
        <h3 className={`text-neutron mb-16`}>
          No internet connected, please check your connection and try again
        </h3>
      )}
    </div>
  );
};

export default Initial;
